import { useLanguage } from "@/i18n/LanguageContext";

export default function LanguageSwitcher({ variant = "desktop" }) {
  const { lang, setLang, languages, t } = useLanguage();

  return (
    <div
      data-testid={`lang-switcher-${variant}`}
      role="group"
      aria-label={t.langSwitcher.label}
      className={
        variant === "desktop"
          ? "flex items-center gap-1 border border-[#E2E0D9] px-1 py-1"
          : "flex items-center gap-1 border border-[#E2E0D9] px-1 py-1 self-start"
      }
    >
      {languages.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => setLang(l.code)}
            data-testid={`lang-btn-${l.code}`}
            aria-pressed={active}
            className={`px-2.5 py-1 text-[10px] uppercase tracking-[0.22em] transition-colors ${
              active
                ? "bg-[#363A33] text-white"
                : "text-[#1A1C19] hover:text-[#A88B7D]"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
